export const ONECLICK_VIDEO_URL = 'https://youtu.be/kle1gpBC0s0?si=SRWEAJZ9NzsLI-Kc';
export const ONECLICK_HELP_PATH = '/help/one-click-mocktest';
